// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cksR","footer":"styles_footer__3fUZV"};